import codes from 'currency-codes';
import getSymbolFromCurrency from 'currency-symbol-map';
export var priceBuilder = function (amount, currency) {
    try {
        var formatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            currency: currency,
        });
        return formatter.format(parseFloat(amount) / 100);
    }
    catch (_a) {
        return "".concat(currency, " ").concat(parseFloat(amount) / 100);
    }
};
export var decimalBuilder = function (amount) {
    var formatter = new Intl.NumberFormat(undefined, {
        style: 'decimal',
    });
    return formatter.format(parseInt(amount));
};
/** Store the currencies we want to enable */
export var ENABLED_CURRENCIES = ['EUR', 'USD', 'SEK', 'NOK'];
/** filtered and mapped currency codes ready for a dropdown */
export var currencyCodes = codes
    .codes()
    .filter(function (code) { return ENABLED_CURRENCIES.includes(code); })
    .map(function (code) { return ({
    label: code,
    value: code.toLowerCase(),
}); });
export var getCurrencyPrefix = function (cur) {
    return cur === undefined || cur === ''
        ? ''
        : "".concat("".concat(getSymbolFromCurrency(cur || '')) || '', " ");
};
/** Possible billing intervals */
export var BILLING_INTERVALS = [
    { value: 'one-time', label: 'One time payment' },
    { value: 'day', label: 'Daily' },
    { value: 'week', label: 'Weekly' },
    { value: 'month', label: 'Monthly' },
    { value: 'year', label: 'Yearly' },
];
export var billingIntervalToPrettyText = function (interval, interval_count) {
    if (interval === void 0) { interval = BILLING_INTERVALS[0].value; }
    if (interval_count === void 0) { interval_count = 1; }
    var billingText = 'once';
    if (interval !== 'one-time') {
        billingText = 'every ';
        billingText +=
            interval_count > 1 ? "".concat(interval_count, " ").concat(interval, "s") : interval;
    }
    return billingText;
};
export var DEFAULT_CURRENCY = 'usd';
